import React from 'react'
import { TextField } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useVehicleDataMutation } from '../../hooks/mutations/useVehicleDataMutation'
import { useParamsFromURL } from '../../hooks/useParamsFromURL'
import { removeMime } from '../../lib/helpers'
import { useAppStore } from '../../store/useAppStore'
import CustomWindow from '../CustomWindow'

const KmInputDialog = () => {
  // Custom hooks
  const {
    vehicleId,
    pNumber = '',
    depotCode,
    startKm,
  } = useParamsFromURL(['pNumber', 'vehicleId', 'depotCode', 'startKm'])

  const [kmInputValue, setKmInputValue] = useState(startKm || '')

  const setIsKmInputVisible = useAppStore((state) => state.setIsKmInputVisible)
  const isKmInputVisible = useAppStore((state) => state.isKmInputVisible)

  const handleKmInputChange = (e) => setKmInputValue(e.target.value)
  const handleKmInputDialogClose = () => setIsKmInputVisible(false)

  const { t } = useTranslation()

  // External state
  const vehicleData = useAppStore((state) => state.vehicleData)

  const { sendVehicleData } = useVehicleDataMutation()

  const handleVehicleDataSending = () => {
    const body = {
      vehicleId,
      pNumber: pNumber || '',
      photoInside: removeMime(vehicleData[0].photo),
      photoFront: removeMime(vehicleData[1].photo),
      photoLeft: removeMime(vehicleData[2].photo),
      photoRear: removeMime(vehicleData[3].photo),
      photoRight: removeMime(vehicleData[4].photo),
      depotCode,
    }
    sendVehicleData(body)
  }

  return (
    <CustomWindow
      title={t('km_input.enter_mileage')}
      open={isKmInputVisible}
      handleClose={handleKmInputDialogClose}
      handleClick={handleVehicleDataSending}
      footerBtn
    >
      <TextField
        fullWidth
        variant="outlined"
        label="Km"
        type="number"
        value={kmInputValue}
        onChange={handleKmInputChange}
        inputProps={{ min: 0 }}
      />
    </CustomWindow>
  )
}

export default KmInputDialog
